import { createContext, useContext, useState } from 'react';
import { Snackbar, Alert } from 'components/ui';
import { FormattedMessage } from 'react-intl';

const InfoContext = createContext();

export const InfoProvider = ({ children }) => {
  const [info, setInfo] = useState(null);

  return (
    <InfoContext.Provider value={setInfo}>
      {info && (
        <Snackbar open={!!info} autoHideDuration={6000} onClose={() => setInfo(null)}>
          <Alert onClose={() => setInfo(null)} severity="success">
            <FormattedMessage id={info} />
          </Alert>
        </Snackbar>
      )}
      {children}
    </InfoContext.Provider>
  );
};

export const useInfo = () => useContext(InfoContext);
